import { render, staticRenderFns } from "./Dzialania.vue?vue&type=template&id=30e27ca2&scoped=true&"
import script from "./Dzialania.vue?vue&type=script&lang=js&"
export * from "./Dzialania.vue?vue&type=script&lang=js&"
import style0 from "./Dzialania.vue?vue&type=style&index=0&id=30e27ca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e27ca2",
  null
  
)

export default component.exports